export const inputStyles = {
  input: {
    borderRadius: '6px !important',
    fontSize: '14px !important',
    height: '40px',
    border: '1px solid #e0e0e0',
    transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
    '&:focus': {
      borderColor: '#850014',
      boxShadow: '0 0 0 2px rgba(133, 0, 20, 0.1)',
    },
  },
  label: {
    fontSize: '13px !important',
    fontWeight: 500,
    marginBottom: '4px',
    color: '#374151',
  },
}

export const textareaStyles = {
  input: {
    borderRadius: '6px !important',
    fontSize: '14px !important',
    border: '1px solid #e0e0e0',
    transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
    '&:focus': {
      borderColor: '#850014',
      boxShadow: '0 0 0 2px rgba(133, 0, 20, 0.1)',
    },
  },
  label: {
    fontSize: '13px !important',
    fontWeight: 500,
    marginBottom: '4px',
    color: '#374151',
  },
}
